module.exports = __webpack_public_path__ + "static/a2-2d4c319f860c2b1aa01fbd2da2c01997.png";